<template>
    <div class="resources">
        <div class="resources__container">
            <!-- Page Heading -->
            <div class="resources__heading">
                <h2 class="resources__title">Contrology RESOURCES</h2>
                <p class="resources__subtitle">
                    Here you will find interesting articles on our blog, the CORE, cool IG reels, and client
                    testimonials about what Contrology apparatus offers them. Learn how we continue to work with Jay
                    Grimes and Karen Frischmann to expand the Contrology suite and help preserve the authentic designs
                    from Joe’s studio.
                </p>
            </div>

            <!-- Articles -->
            <div class="resources__articles">
                <div class="resources__articles-container">
                    <div class="resources__articles-flex">
                        <h3 class="resources__articles-title">Articles on the core</h3>
                        <a
                            class="resources__articles-link"
                            href="https://thecore.balancedbody.com/category/fitness/contrology/"
                            target="_blank"
                        >
                            Read All
                            <img src="@/assets/articles/icon_arrow-up-right.svg" alt="up right arrow icon" />
                        </a>
                    </div>
                    <ul class="resources__articles-cards">

                        <li class="resources__articles-card">
                            <a
                                href="https://thecore.balancedbody.com/classical-pilates-why-isnt-everybody-doing-this/"
                                target="_blank"
                            >
                                <div class="resources__articles-card-media">
                                    <img
                                        src="@/assets/articles/resources-article-classical-pilates@1x.jpg"
                                        srcset="@/assets/articles/resources-article-classical-pilates@2x.jpg 2x"
                                        alt="Woman doing pilates on an EXO Chair"
                                    />
                                </div>
                                <div class="resources__articles-card-body">
                                    <p class="resources__articles-card-title">
                                        Classical Pilates: Why isn’t everybody doing this?
                                    </p>
                                    <p class="resources__articles-card-details">
                                        What about the classical method makes it less attractive? How can we change
                                        that?
                                    </p>
                                </div>
                            </a>
                        </li>
                        <li class="resources__articles-card">
                            <a
                                href="https://thecore.balancedbody.com/pilates-is-like-getting-a-good-massage/"
                                target="_blank"
                            >
                                <div class="resources__articles-card-media">
                                    <img
                                        src="@/assets/articles/resources-article-pilates-massage@1x.jpg"
                                        srcset="@/assets/articles/resources-article-pilates-massage@2x.jpg 2x"
                                        alt="A woman doing pilates on a mat"
                                    />
                                </div>
                                <div class="resources__articles-card-body">
                                    <p class="resources__articles-card-title">
                                        Pilates is like Getting a Good Massage
                                    </p>
                                    <p class="resources__articles-card-details">
                                        Joe Pilates carefully crafted the mat work and designed this beautiful method,
                                        as a full-body workout from head to toe.
                                    </p>
                                </div>
                            </a>
                        </li>
                        <li class="resources__articles-card">
                            <a href="https://thecore.balancedbody.com/mens-exercises-by-joe-pilates/" target="_blank">
                                <div class="resources__articles-card-media">
                                    <img
                                        src="@/assets/articles/resources-article-mens-exercises@1x.jpg"
                                        srcset="@/assets/articles/resources-article-mens-exercises@2x.jpg 2x"
                                        alt="A man doing pilates on a barrel"
                                    />
                                </div>
                                <div class="resources__articles-card-body">
                                    <p class="resources__articles-card-title">
                                        Men’s Exercises by Joe Pilates
                                    </p>
                                    <p class="resources__articles-card-details">
                                        In Joe’s studio, there were specific exercises intended just for men. To
                                        understand why, one must recognize 3 things.
                                    </p>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- Video Slider -->
            <div class="resources__videos">
                <div class="resources__videos-container">
                    <h3 class="resources__videos-title">Follow Us on Instagram</h3>
                    <carousel
                        loop
                        navigationEnabled
                        :perPage="5"
                        :perPageCustom="[
                            [0, 1],
                            [768, 3],
                            [1024, 4],
                            [1235, 5],
                        ]"
                        paginationActiveColor="#ffffff"
                        paginationColor="#aeaeae"
                        :paginationSize="7"
                        :paginationPadding="5"
                        :navigationNextLabel="nextIcon"
                        :navigationPrevLabel="prevIcon"
                    >
                        <slide :key="item.id" v-for="item in media">
                            <video playsinline controls muted>
                                <source :src="item.media_url" />
                            </video>
                        </slide>
                    </carousel>
                    <a href="https://www.instagram.com/contrology.bb/" target="_blank">
                        More IG Reels
                        <img src="@/assets/reels/icon_insta.svg" alt="instagram icon" />
                    </a>
                </div>
            </div>

            <!-- Quote Slider -->
            <div class="resources__quotes">
                <div class="resources__quotes-container">
                    <h3 class="resources__quotes-title">What Our Clients Say</h3>
                    <carousel
                        loop
                        navigationEnabled
                        sspacePadding="50"
                        :perPage="3"
                        :perPageCustom="[
                            [0, 1],
                            [768, 2],
                            [1024, 3],
                        ]"
                        paginationActiveColor="#ffffff"
                        paginationColor="#aeaeae"
                        :paginationSize="7"
                        :paginationPadding="5"
                        :navigationNextLabel="nextIcon"
                        :navigationPrevLabel="prevIcon"
                    >
                        <slide>
                            <div class="resources__quote-card">
                                <img
                                    class="resources__quote-card-icon"
                                    src="@/assets/icon_quote.svg"
                                    alt="quote icon"
                                />
                                <p class="resources__quote-text">
                                    What I love about the Contrology reformer is...if I lose my center, it tells me that
                                    i am not ready for this exercise.
                                </p>
                                <div class="resources__quote-author">
                                    <img
                                        src="@/assets/quotes/headshot-alexa-idama@1x.jpg"
                                        srcset="@/assets/quotes/headshot-alexa-idama@2x.jpg 2x"
                                        alt="author"
                                    />
                                    <p class="resources__quote-author-name">
                                        ~Alexa Idama
                                    </p>
                                </div>
                            </div>
                        </slide>
                        <slide>
                            <div class="resources__quote-card">
                                <img
                                    class="resources__quote-card-icon"
                                    src="@/assets/icon_quote.svg"
                                    alt="quote icon"
                                />
                                <p class="resources__quote-text">
                                    The apparatus gives you a lot of information... maybe you that you didn't want to
                                    know about your body and the exercises.
                                </p>
                                <div class="resources__quote-author">
                                    <img
                                        src="@/assets/quotes/headshot-andrea-maida@1x.jpg"
                                        srcset="@/assets/quotes/headshot-andrea-maida@2x.jpg 2x"
                                        alt="author"
                                    />
                                    <p class="resources__quote-author-name">
                                        ~Andrea Maida
                                    </p>
                                </div>
                            </div>
                        </slide>
                        <slide>
                            <div class="resources__quote-card">
                                <img
                                    class="resources__quote-card-icon"
                                    src="@/assets/icon_quote.svg"
                                    alt="quote icon"
                                />
                                <p class="resources__quote-text">
                                    The arm chair actually is so essential and so fundamental... There's not a single
                                    session where I won't use my arm chair.
                                </p>
                                <div class="resources__quote-author">
                                    <img
                                        src="@/assets/quotes/headshot-annie-paz@1x.jpg"
                                        srcset="@/assets/quotes/headshot-annie-paz@2x.jpg 2x"
                                        alt="author"
                                    />
                                    <p class="resources__quote-author-name">
                                        ~Annie Paz
                                    </p>
                                </div>
                            </div>
                        </slide>
                        <slide>
                            <div class="resources__quote-card">
                                <img
                                    class="resources__quote-card-icon"
                                    src="@/assets/icon_quote.svg"
                                    alt="quote icon"
                                />
                                <p class="resources__quote-text">
                                    I love the Contrology line for the craftsmanship & design... Each piece is solid,
                                    stable & made of quality materials.
                                </p>
                                <div class="resources__quote-author">
                                    <img
                                        src="@/assets/quotes/headshot-cid-ford@1x.jpg"
                                        srcset="@/assets/quotes/headshot-cid-ford@2x.jpg 2x"
                                        alt="author"
                                    />
                                    <p class="resources__quote-author-name">
                                        ~Cid Ford
                                    </p>
                                </div>
                            </div>
                        </slide>
                        <slide>
                            <div class="resources__quote-card">
                                <img
                                    class="resources__quote-card-icon"
                                    src="@/assets/icon_quote.svg"
                                    alt="quote icon"
                                />
                                <p class="resources__quote-text">
                                    The Contrology reformer reminds me a lot of what I used to work out on in Romana's
                                    studio... the springs are perfect.
                                </p>
                                <div class="resources__quote-author">
                                    <img
                                        src="@/assets/quotes/headshot-gina-papalia@1x.jpg"
                                        srcset="@/assets/quotes/headshot-gina-papalia@2x.jpg 2x"
                                        alt="author"
                                    />
                                    <p class="resources__quote-author-name">
                                        ~Gina papalia
                                    </p>
                                </div>
                            </div>
                        </slide>
                        <slide>
                            <div class="resources__quote-card">
                                <img
                                    class="resources__quote-card-icon"
                                    src="@/assets/icon_quote.svg"
                                    alt="quote icon"
                                />
                                <p class="resources__quote-text">
                                    What I love about the Contrology reformer is that it just teaches the body what it
                                    needs to do.
                                </p>
                                <div class="resources__quote-author">
                                    <img
                                        src="@/assets/quotes/headshot-joel-crosby@1x.jpg"
                                        srcset="@/assets/quotes/headshot-joel-crosby@2x.jpg 2x"
                                        alt="author"
                                    />
                                    <p class="resources__quote-author-name">
                                        ~Joel Crosby
                                    </p>
                                </div>
                            </div>
                        </slide>
                    </carousel>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";

export default {
    name: "resources",

    metaInfo: {
        title: "Resources - Contrology Pilates Events",
        titleTemplate: "%s",
        meta: [
            {
                name: "description",
                content: "Here you will find interesting articles on our blog, the CORE, cool IG reels",
            },
            {
            property: "og:image",
            content: "https://s3.amazonaws.com/s3.pilates.com/contrology/contrology-default.jpg"
            }
        ],
    },

    components: {
        Carousel,
        Slide,
    },

    data() {
        return {
            media: [],
            hiddenImages: [],
        };
    },

    computed: {
        nextIcon() {
            return `<svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="20.4395" cy="20.5" r="20" fill="black" />
                    <path
                        d="M16.4395 8.51965L27.4739 20.2438L16.4395 31.9679"
                        stroke="white"
                        stroke-width="2.5"
                        stroke-linecap="round"
                    />
                </svg>`;
        },

        prevIcon() {
            return `<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="20" cy="20" r="20" transform="rotate(180 20 20)" fill="black" />
                    <path
                        d="M24 31.9803L12.9655 20.2562L24 8.53207"
                        stroke="white"
                        stroke-width="2.5"
                        stroke-linecap="round"
                    />
                </svg>`;
        },
    },

    mounted() {
        this.getInstaMedia();
    },

    methods: {
        async getInstaMedia() {
            const localStorageInstaVideos = JSON.parse(localStorage.getItem("instaVideos"));
            const localStorageDataTime = +localStorage.getItem("instaDate");
            const expired = new Date().getTime() - localStorageDataTime > 1 * 60 * 60 * 1000;
            if (localStorageInstaVideos && !expired) return (this.media = localStorageInstaVideos);

            const res = await fetch(
                "https://graph.instagram.com/me/media?fields=id,media_type,media_url,thumbnail_url,permalink,username,timestamp&access_token=IGAAI2BjOfsXNBZAE1BQk1qYkV0ZAzNZAYTMwNTVqdllHUFRSbnByMjlSMWFhTEY4cDJwUHIwTG1IVEJHbWZAkWm5HeVR3b3M3bjFSbHNDWE9FYlljUjdDT1c4QkdzT1E2bmEzRVhvVkRJTnpURS1rY0FPY3RR&limit=50"
            );
            const instaData = await res.json();

            this.media = instaData.data.filter(({ media_type }) => media_type === "VIDEO");
            localStorage.setItem("instaVideos", JSON.stringify(this.media));
            localStorage.setItem("instaDate", new Date().getTime());
        },

        setPlayingVideos(index, e) {
            e.target.paused ? e.target.play() : e.target.pause();
            this.hiddenImages.includes(index) ? null : this.hiddenImages.push(index);
            return null;
        },
    },
};
</script>

<style scoped>
.resources {
    margin: 0 -30px;
}
/* Heading */
.resources__heading {
    max-width: 1000px;
    margin: auto;
}
.resources__title {
    font-family: var(--noto);
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 118%;
    text-align: center;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #333333;
    margin: 0 0 20px;
}
.resources__subtitle {
    font-family: var(--roboto);
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 152.34%;
    color: #000000;
}

/* Articles */
.resources__articles {
    margin: 80px 0 50px;
    padding-bottom: 65px;
    border-bottom: 1px solid #000;
}
.resources__articles-container {
    max-width: 1000px;
    margin: auto;
}
.resources__articles-title {
    font-family: var(--noto);
    font-style: normal;
    font-weight: 400;
    font-size: 26px;
    line-height: 118%;
    text-transform: uppercase;
    color: #000000;
    text-align: left;
    margin: 0;
}
.resources__articles-cards {
    position: relative;
    display: grid;
    grid-template-columns: 100%;
    list-style: none;
    padding: 0;
    row-gap: 50px;
    margin: 0;
}
.resources__articles-flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.resources__articles-card > a {
    display: contents;
}
.resources__articles-card {
    display: grid;
    grid-template-columns: 100%;
    row-gap: 16px;
    cursor: pointer;
}
.resources__articles-card-media {
    position: relative;
    width: 100%;
    background-color: #000;
}
.resources__articles-card-media::before {
    display: block;
    content: "";
    padding-top: min(calc((217 / 320) * 100%), 350px);
    min-height: 170px;
}
.resources__articles-card-media > img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    transition: opacity 0.25s ease;
}
.resources__articles-card-body {
    display: grid;
    row-gap: 20px;
}
.resources__articles-card-title {
    font-family: var(--noto);
    font-style: normal;
    font-weight: 300;
    font-size: 20px;
    line-height: 130%;
    color: #333;
    margin: 0;

    text-decoration: underline;
    text-decoration-color: transparent;
    -webkit-text-decoration-color: transparent;
    -moz-text-decoration-color: transparent;
    text-underline-offset: 2px;
}
.resources__articles-card-details {
    margin: 0;
    font-family: var(--roboto);
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 152.34%;
    color: #000000;
}

/* Quote Slider */
.resources__quotes {
    margin: 70px calc(50% - 50vw);
    background: rgba(0, 0, 0, 0.75);
    padding: 70px 0 50px;
}
.resources__quotes-title {
    font-family: var(--noto);
    font-style: normal;
    font-weight: 400;
    font-size: 26px;
    line-height: 118%;
    text-align: center;
    text-transform: uppercase;
    color: #fff;
    margin: 0 auto 50px;
    max-width: 80%;
}
.resources__quote-card {
    border-radius: 5px;
    overflow: hidden;
    height: 100%;
    background-color: #fff;
    margin: 0;
    padding: 30px 16px;
    display: grid;
    align-items: flex-start;
    align-content: center;
}
.resources__quote-card-icon {
    display: block;
    margin: auto;
    width: 28px;
    height: 28px;
}
.resources__quote-text {
    font-family: var(--noto);
    font-style: italic;
    font-weight: 400;
    font-size: 16px;
    line-height: 130%;
    text-align: center;
    color: #000000;
    max-width: 87%;
    margin: 20px auto 35px;
}
.resources__quote-author {
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    justify-content: center;
    align-items: center;
}
.resources__quote-author > img {
    display: inline-block;
    width: 54px;
    height: 54px;
    border-radius: 50%;
    object-fit: cover;
    object-position: center;
}
.resources__quote-author > p {
    font-family: var(--roboto);
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 135%;
    text-align: center;
    color: #000000;
    margin: 0;
}
::v-deep .resources__quotes .VueCarousel-inner {
    width: 70%;
    margin: auto;
}
::v-deep .resources__quotes .VueCarousel-slide {
    padding: 0 8px;
}
::v-deep .resources__quotes .VueCarousel-dot:focus {
    outline: none;
}
::v-deep .resources__quotes .VueCarousel-dot-container {
    margin-top: 0;
}
::v-deep .resources__quotes .VueCarousel-navigation-button {
    transform: translate(0, -50%);
    outline: none;
}

/* Video Slider */
.resources__videos {
    margin: 70px calc(50% - 50vw);
}
.resources__videos-title {
    font-family: var(--noto);
    font-style: normal;
    font-weight: 400;
    font-size: 26px;
    line-height: 118%;
    text-align: center;
    text-transform: uppercase;
    color: #000000;
    margin: 0 auto 50px;
    max-width: 80%;
}
.resources__videos video {
    width: 100%;
    height: 100%;
    background-color: black;
}
.resources__videos a {
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 12px;
    max-width: 250px;
    margin: 30px auto 0;
    font-family: var(--roboto);
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    line-height: 18px;
    text-align: center;
    text-transform: uppercase;
    color: #000000;
    border: 1px solid black;
    border-radius: 3px;
    text-decoration: none;
    padding: 15px 40px;
    cursor: pointer;
}
::v-deep .resources__videos .VueCarousel-inner {
    width: calc(213px * 1);
    padding-left: 10px;
}
::v-deep .resources__videos .VueCarousel-slide {
    position: relative;
    max-width: 213px;
    height: 360px;
    cursor: pointer;
    padding-right: 10px;
}
::v-deep .resources__videos .VueCarousel-dot-container {
    display: none;
}
::v-deep .resources__videos .VueCarousel-navigation-button {
    transform: translate(0, -50%);
    outline: none;
}

@media only screen and (min-width: 768px) {
    /* Heading */
    .resources__title {
        text-align: left;
        font-size: 34px;
    }
    .resources__subtitle {
        margin: 0;
    }

    /* Articles */
    .resources__articles {
        padding-bottom: 80px;
    }

    .resources__articles-cards {
        display: flex;
        flex-wrap: wrap;
        column-gap: 2%;
        align-items: flex-start;
    }

    .resources__articles-link:hover {
        text-decoration: underline;
    } 
    .resources__articles-card {
        flex: 1 1 32%;
        min-width: 288px;
        max-width: 49%;
        row-gap: 24px;
    }
    .resources__articles-card:hover img {
        opacity: 0.8;
    }
    .resources__articles-card:hover .resources__articles-card-title {
        text-decoration-color: #000;
        -webkit-text-decoration-color: #000;
        -moz-text-decoration-color: #000;
        transition: all 0.2s 0.05s ease-out;
    }

    /* Quote Slider */
    .resources__quote-card {
        padding: 30px 35px 30px 35px;
        align-items: stretch;
        align-content: stretch;
    }
    .resources__quote-card-icon {
        margin: 0;
    }
    .resources__quote-text {
        text-align: left;
        margin: 20px 0 35px;
    }
    .resources__quote-author {
        flex-direction: row;
        column-gap: 12px;
        justify-content: flex-start;
        align-self: end;
    }
    ::v-deep .resources__quotes .VueCarousel-inner {
        width: 85%;
        margin: 0;
    }

    /* Video Slider */
    .resources__videos {
        margin: 70px 0;
    }
    ::v-deep .resources__videos .VueCarousel-inner {
        width: calc(213px * 3);
        padding-left: 10px;
    }
    ::v-deep .resources__videos .VueCarousel-dot-container {
        display: block;
    }
    ::v-deep .resources__videos .VueCarousel-navigation-button.VueCarousel-navigation-prev {
        transform: translate(-100%, -50%);
    }
    ::v-deep .resources__videos .VueCarousel-navigation-button.VueCarousel-navigation-next {
        transform: translate(100%, -50%);
    }
}

@media only screen and (min-width: 1024px) {
    /* Video Slider */
    ::v-deep .resources__videos .VueCarousel-inner {
        width: calc(213px * 4);
        padding-left: 10px;
    }
}

@media only screen and (min-width: 1235px) {
    /* Video Slider */
    ::v-deep .resources__videos .VueCarousel-inner {
        width: calc(213px * 5);
        padding-left: 10px;
    }
}
</style>
